var map = {
	"./3.jpg": 94,
	"./4.jpg": 95,
	"./5.jpg": 96,
	"./6.jpg": 97,
	"./7.jpg": 98,
	"./studio2.jpeg": 99,
	"./studio3.jpeg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93;